const RAW = [
    { text: 'I', startMs: 200, endMs: 340 },
    { text: 'built', startMs: 350, endMs: 640 },
    { text: 'this', startMs: 650, endMs: 820 },
    { text: 'app', startMs: 830, endMs: 1080 },
    { text: 'because', startMs: 1090, endMs: 1460 },
    { text: 'I', startMs: 1470, endMs: 1560 },
    { text: 'was', startMs: 1570, endMs: 1720 },
    { text: 'tired', startMs: 1730, endMs: 2060 },
    { text: 'of', startMs: 2070, endMs: 2170 },
    { text: 'switching', startMs: 2180, endMs: 2600 },
    { text: 'between', startMs: 2610, endMs: 2900 },
    { text: 'five', startMs: 2910, endMs: 3160 },
    { text: 'different', startMs: 3170, endMs: 3560 },
    { text: 'apps.', startMs: 3570, endMs: 3980 },
    // pause
    { text: 'um', startMs: 4600, endMs: 4820 },
    { text: 'in', startMs: 4830, endMs: 4980 },
    { text: 'the', startMs: 4990, endMs: 5100 },
    { text: 'first', startMs: 5110, endMs: 5380 },
    { text: 'month', startMs: 5390, endMs: 5720 },
    { text: 'it', startMs: 5730, endMs: 5860 },
    { text: 'made', startMs: 5870, endMs: 6120 },
    { text: '$10,000', startMs: 6130, endMs: 6720 },
    { text: 'in', startMs: 6730, endMs: 6860 },
    { text: 'revenue.', startMs: 6870, endMs: 7420 },
    // pause
    { text: 'Conversions', startMs: 8000, endMs: 8560 },
    { text: 'jumped', startMs: 8570, endMs: 8900 },
    { text: 'by', startMs: 8910, endMs: 9040 },
    { text: '40%', startMs: 9050, endMs: 9520 },
    { text: 'almost', startMs: 9530, endMs: 9860 },
    { text: 'overnight.', startMs: 9870, endMs: 10480 },
    // pause
    { text: 'Never', startMs: 11100, endMs: 11460 },
    { text: 'make', startMs: 11470, endMs: 11720 },
    { text: 'this', startMs: 11730, endMs: 11920 },
    { text: 'mistake.', startMs: 11930, endMs: 12480 },
];
export function demoTranscriptWords() {
    return RAW.map((r, i) => ({
        id: `demo_w${i}`,
        text: r.text,
        startMs: r.startMs,
        endMs: r.endMs,
        confidence: 0.9,
    }));
}
export const DEMO_LANGUAGE = 'en';
export const DEMO_DURATION_MS = 13000;
//# sourceMappingURL=transcript.js.map